import { render, staticRenderFns } from "./setWorkGroupInfo.vue?vue&type=template&id=91ed5876&scoped=true"
import script from "./setWorkGroupInfo.vue?vue&type=script&lang=js"
export * from "./setWorkGroupInfo.vue?vue&type=script&lang=js"
import style0 from "./setWorkGroupInfo.vue?vue&type=style&index=0&id=91ed5876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ed5876",
  null
  
)

export default component.exports